import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The phone "Sorted by <column> · Reset" line shown under a table's header while it is off its
 * default sort (RA-2838 on Movers, RA-2879 on Portfolio). On a phone the sorted column is often
 * off-screen, so this names it. The host owns the sort state: it decides when the line shows and
 * what Reset does, and supplies the column's translation key.
 */
@Component({
  selector: 'rms-sort-scope-line',
  templateUrl: './sort-scope-line.component.html',
  styleUrls: ['./sort-scope-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SortScopeLineComponent {
  /** Translation key of the column the table is sorted by. */
  @Input() columnLabelKey = '';
  /** Emitted when the user taps Reset. */
  @Output() resetSort = new EventEmitter<void>();

  public onReset(): void {
    this.resetSort.emit();
  }
}
